export default function () {
  const yearParagraph = document.querySelector('.promo__year');
  const currentYear = new Date().toLocaleDateString('en-US', { year: 'numeric'});

  yearParagraph.innerText = currentYear
}
